// extracted by mini-css-extract-plugin
export default {"container":"NoticeBanner_container__Vdrbj","wrap":"NoticeBanner_wrap__1wbGZ","close":"NoticeBanner_close__6Ng1y","link":"NoticeBanner_link__lvNJF","img":"NoticeBanner_img__aXfAh"};